import { combineReducers } from 'redux';
import filterReducer from './utils/filter/filterReducer';
import dataSetReducer from './utils/dataSet/dataSetReducer';
import commonReducer from './utils/common/commonReducer';


const reducer = combineReducers({
  filter: filterReducer,
  dataSet: dataSetReducer,
  common: commonReducer,
});

export default reducer;
